import React, { ChangeEvent, ReactNode, useRef } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { FileInfo, uploadFile } from "../../service/file.service";
import { enqueueSnackbar } from "notistack";

export function FileUpload({onUpload, label,accept, sublabel}: {accept?:string, label?: ReactNode,sublabel?: ReactNode, onUpload: (file:FileInfo) => void}) {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleButtonClick = () => {
        fileInputRef.current && fileInputRef.current.click();
    };

    const handleFileChange = (event:ChangeEvent<HTMLInputElement>) => {
        if(!event.target.files) {
            return;
        }
        const file = event.target.files[0];
        if (file) {
            fileToBase64(file).then((data) => {
                return uploadFile({
                    originalName: file.name,
                    content: data
                })
            }).then((fileInfo) => {
                onUpload(fileInfo.data);
            }).catch((error) => {
                enqueueSnackbar({message: 'Failed to upload file ' + error.message, variant: 'error'})
            })
        }
    };

    return (
        <Stack flexDirection={"row"} gap={'15px'}>
            <input
                type="file"
                accept={accept}
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            {label && <Button variant="contained" color="primary" onClick={handleButtonClick}>
                {label}
            </Button>}
            {sublabel && <Typography variant="body2" mt={1}>
                {sublabel}
            </Typography>}
        </Stack>
    );
}

function fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                resolve(result.split(',')[1]);
            } else {
                reject(new Error('FileReader result is not a string.'));
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file); // reads and encodes the file as Base64
    });
}